module.exports = __webpack_public_path__ + "img/fundo-login-hc.36014676.png";